import { useEffect, useState } from 'react';

/**
 * Check if clicked outside ref (component)
 * if clicked outside returns false
 */
export function useClickOut(ref: any) {
  const [clickedOut, setClickedOut] = useState<boolean>(false);

  const handleClickOutside = (e: any) => {
    if (ref.current && !ref.current.contains(e.target)) setClickedOut(true);
    if (ref.current && ref.current.contains(e.target)) setClickedOut(false);
  };

  useEffect(() => {
    setClickedOut(false);
    document.addEventListener('mousedown', handleClickOutside);
  }, []);

  useEffect(() => {
    // add event listener
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      // Unbind event listener
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [ref]);

  return clickedOut;
}
